import React, { useState } from "react";
import PropTypes from "prop-types";
import "./Container.css";

const Container = props => {
  
  return (
    <>
      <div id={props.id} className={`row center ${props.className}`} style={props.style}>
        <div className="content">{props.children}</div>
      </div>
    </>
  );
};

Container.propTypes = {
  children: PropTypes.node
};

export default Container;
